'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dId$0024 from "./presto.types$-Directive-Id$.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dId$0024 from "./presto.types$-Restricted-Domain-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_Domains$$anon$2(outer) {
  this.aN5 = null;
  this.aN3 = null;
  this.aN4 = false;
  this.aN1 = null;
  this.aN2 = false;
  this.aN6 = false;
  this.aN7 = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aN5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Domains$$anon$2 as $c_Lpresto_Domains$$anon$2 };
$p = $c_Lpresto_Domains$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Domains$$anon$2;
/** @constructor */
function $h_Lpresto_Domains$$anon$2() {
}
export { $h_Lpresto_Domains$$anon$2 as $h_Lpresto_Domains$$anon$2 };
$h_Lpresto_Domains$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aN5;
});
$p.t = (function() {
  if ((!this.aN4)) {
    this.aN3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("domain", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aN4 = true;
  }
  return this.aN3;
});
$p.ae = (function() {
  if ((!this.aN2)) {
    this.aN1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dDirective$002dId$0024.$m_Lpresto_types$DirectiveId$().ady(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRestricted$002dDomain$002dId$0024.$m_Lpresto_types$RestrictedDomainId$().GI(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aN2 = true;
  }
  return this.aN1;
});
$p.w = (function() {
  if ((!this.aN7)) {
    this.aN6 = false;
    this.aN7 = true;
  }
  return this.aN6;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Domains$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Domains$$anon$2, "presto.Domains$$anon$2", ({
  Hq: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Domains$$anon$2 as $d_Lpresto_Domains$$anon$2 };
//# sourceMappingURL=presto.-Domains$$anon$2.js.map
